import {useCallback} from 'react';
import {debounce} from 'lodash';

export function useDebounce(callback, deps, wait = 300) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback(debounce(callback, wait), deps);
}
